module.exports = __webpack_public_path__ + "static/media/13A.1bf54aa8.png";